import './contacts.scss';

export default function Contacts() {
    const contacts = document.querySelectorAll('.contacts');

    if (contacts.length > 0) {
        contacts.forEach(contact => {
            const email = contact.querySelector('.mail .description a') as HTMLElement;
            const phone = contact.querySelector('.phone .description a') as HTMLElement;

            if(email) {
                email.addEventListener('click', () => {
                    const emailAddress = email.innerHTML;
                    window.location.href = `mailto:?to=${emailAddress}`;
                })

                email.addEventListener('keypress', function (e) {
                    if(e.code === 'Enter') {
                        const emailAddress = email.innerHTML;
                        window.location.href = `mailto:?to=${emailAddress}`;
                    }
                })
            }

            if(phone) {
                phone.addEventListener('click', () => {
                    const phoneNumber = phone.innerHTML;
                    window.open(`tel:${phoneNumber}`);
                })

                phone.addEventListener('keypress', function (e) {
                    if(e.code === 'Enter') {
                        const phoneNumber = phone.innerHTML;
                        window.open(`tel:${phoneNumber}`);
                    }
                })
            }
        })
    }
}